<template>
  <div id="popup-detail">
      <transition name="modal" v-if="isActive">
          <div class="modal-mask">
              <div class="modal-wrapper">
                  <div class="modal-container">
                      <div class="modal-header">
                          <a class="modal-default-button" @click="close">
                              <span><i class="ion-android-close"></i></span>
                          </a>
                      </div>
                      <div class="modal-content">
                          <!-- <div class="banner-giveaway">
                              <img src="https://ik.imagekit.io/zlt25mb52fx/ahmcdn/uploads/page/banner/banner-community-giveaway-15052024-053103.png" alt="Banner Community Giveaway">
                          </div> -->
                          <div class="content-body">
                            <h3>{{ media.title }}</h3>
                            <div class="desc" v-html="media.description"></div>
                          </div>
                          <!-- <a :href="`${main_site_url}/CommunityGiveaway`" target="_blank" rel="noopener noreferrer nofollow">Link Community Giveaway</a> -->
                      </div>
                  </div>
              </div>
          </div>
      </transition>
  </div>
</template>

<script>
export default {
    props: ['slide'],
    data() {
        return {
            isActive: false,
            main_site_url: main_site_url,
            media: null
        }
    },
    methods: {
        show(data){
            this.isActive = !this.isActive;
            this.media = data;
        },
        close(){
            this.isActive = !this.isActive;
        }
    },
}
</script>

<style lang="scss" scoped>
.modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.7);
    display: table;
    transition: opacity 0.3s ease;
}

.modal-wrapper {
    display: table-cell;
    vertical-align: middle;
    padding:20px;
}

.modal-container {
    width: 50%;
    margin: 0px auto;
    padding: 15px;
    background-color: #fff;
    border-radius: 10px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
    transition: all 0.3s ease;
    font-family: Helvetica, Arial, sans-serif;
    position: relative;
    max-height: 80vh;
}

.modal-header h3 {
    margin-top: 0;
}

.modal-body {
    margin: 20px 0;
}

.modal-default-button {
    right: -18px;
    top: -18px;
    cursor: pointer;
    background: #E61B33;
    display: block;
    width: 36px;
    height: 36px;
    text-align: center;
    line-height: 36px;
    color: #fff;
    border-radius: 100px;
    position: absolute;
    cursor: pointer;
    span {
        font-size: 20px;
    }
}
.modal-default-button:hover{
    background: #000000;
}
.modal-content{
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  pointer-events: auto;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 0.3rem;
  outline: 0;
  // text-align: center;
  padding: 25px;
  color:#000000;

  h3 {
    margin: 0;
    margin-top: 20px;
    margin-bottom: 20px;
    color: #000000;
  }

  .content-body {
    overflow-y: auto;
    max-height: 400px;
    color: #000000;

    .desc {
      color: #000000;

      p {
        color: #000000;
      }

      ul {
        list-style-type: initial;
      }

      ul li {
        list-style-type: initial;
      }
    }
  }
}

/*
* The following styles are auto-applied to elements with
* transition="modal" when their visibility is toggled
* by Vue.js.
*
* You can easily play with the modal transition by editing
* these styles.
*/

.modal-enter {
    opacity: 0;
}

.modal-leave-active {
    opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
-webkit-transform: scale(1.1);
    transform: scale(1.1);
}

.wrap-box, .wrap-box-thumb {
    border: 1px solid #DBDBDB;
    border-radius: 10px;
    position: relative;
    box-sizing: border-box;
    .wrap-content {
        padding: 20px;
        display: flex;
        justify-content: center;
        .show-img img {
            width: 100%;
        }
    }
}
.wrap-content-thumb {
    padding: 10px;
    display: flex;
    justify-content: center;
    cursor: pointer;
}

.isActive {
    border: 1px solid #E61B33;
    border-radius: 10px;
    position: relative;
    box-sizing: border-box;
}
// ==================================================  MOBILE RESPONSIVE
@media (max-width: 768px){
    .modal-container{
        width: 100%;
        padding: 15px;
            iframe{
                height: 300px;
            }
    }

    .modal-content {
        padding: 20px;
    }
}
</style>